import { render, staticRenderFns } from "./BooksCreate.vue?vue&type=template&id=f710d9fa&"
import script from "./BooksCreate.vue?vue&type=script&lang=js&"
export * from "./BooksCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports